import { useQuery } from "react-query";
import API from "../shared-utils/api";
export const getEventDetail = async (event_id, walkin) => {
    const walkin_booking = walkin ? true : false;
    const { data } = await API.get(`/api/v1/rbzo/events/customer/${event_id}?walkin_booking=${walkin_booking}`);
    return data;
};
export const useEvent = (event_id, walkin, enable = true, options) => {
    return useQuery(["event", event_id, walkin], () => getEventDetail(event_id, walkin), {
        enabled: enable && !!event_id,
        ...options,
    });
};
